<template>
  <footer>
    <p>
      <a target="_blank" href="https://chinet.org">CHINET</a>
    </p>
    <p>
      <a target="_blank" href="https://chinet.org/files/logo">Logo Pack</a>
    </p>
    <p>
      <a target="_blank" href="https://chinet.org/files/font">CHI Font</a>
    </p>
    <p>
      <a target="_blank" href="https://chinet.org/wearechi">Branding Guidelines</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>

<style scoped>
footer {
  background: #9e1b32;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
footer p {
  margin: 5px;
}

footer a {
  color: #fff;
  font-weight: 600;
}

@media only screen and (max-width: 767px) {
  footer {
    flex-direction: column;
  }
}
</style>
